const regExpEscape = /[/\-\\^$*+?.()|[\]{}]/g;

const getEscapedRegExpText = (text) => {
  return typeof text === 'string' ? text.replaceAll(regExpEscape, '\\$&') : '';
};

export default getEscapedRegExpText;



// WEBPACK FOOTER //
// ./src/utils/getEscapedRegExpText.js